import { render } from "./AppViewer.vue?vue&type=template&id=8ffdc44e&scoped=true"
import script from "./AppViewer.vue?vue&type=script&lang=js"
export * from "./AppViewer.vue?vue&type=script&lang=js"

import "./AppViewer.vue?vue&type=style&index=0&id=8ffdc44e&lang=scss&scoped=true"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ffdc44e"]])

export default __exports__